// extracted by mini-css-extract-plugin
export default {"slideshow":"MultiAnswerMultiChoiceQuestion__slideshow___PS0p8","button":"MultiAnswerMultiChoiceQuestion__button___OJB3a"};